import { render, staticRenderFns } from "./SubscriptionBadge.vue?vue&type=template&id=58c42ecd&scoped=true"
import script from "./SubscriptionBadge.vue?vue&type=script&lang=js"
export * from "./SubscriptionBadge.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionBadge.vue?vue&type=style&index=0&id=58c42ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c42ecd",
  null
  
)

export default component.exports